import React, { FC, useEffect, useState } from 'react';
import SimpleHeader from '../../components/layout/SimpleHeader';
import SelectCampus from '../../components/SelectCampus';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';
import { DatePicker, Select, Table, TableColumnsType, Tooltip } from 'antd';
import moment from 'moment/moment';
import Button from '../../components/Button';
import DatePickerTable from '../../components/statistics/DatePickerTable';
import { useTranslation } from 'react-i18next';
import useAxios from '../../hooks/useAxios';
import {
  IGetPaymentOverallSales,
  IPaymentOverallSales,
  IPaymentOverallSalesParams,
} from '../../models/nicePayments.model';
import ErrorResponse from '../../components/ErrorResponse';
import Loader from '../../components/Loader';
import useAuth from '../../hooks/useAuth';
import { getCommonCodeLabel } from '../../lib/store';
import { getPaymentOverallSales } from '../../api/nicePayments.api';
import DownloadButton from '../../components/DownloadButton';
import config from '../../lib/config';
import Pagination from '../../components/Pagination';
import { cloneDeep } from 'lodash';
import exportTable from '../../lib/exportTable';
import Radio from '../../components/Radio';
import { DateTableType } from '../../constans';
import TableEmpty from '../../components/common/TableEmpty';
import { getWebUrl } from '../../lib/util';

const OverallSalesNice: FC = () => {
  const { t, i18n } = useTranslation();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { serverDate } = useSelector((state: RootState) => state.serverDate);
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  const { writeAuthYn } = useAuth();
  const {
    data: res,
    isLoading,
    error,
    execute,
  } = useAxios<IGetPaymentOverallSales>();
  const {
    data: res2,
    isLoading: isLoading2,
    error: error2,
    execute: execute2,
  } = useAxios<IGetPaymentOverallSales>();

  const [isFirstRun, setIsFirstRun] = useState(true);
  const [paymentChannelCode, setPaymentChannelCode] = useState();
  const [orderId, setOrderId] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [pageNo, setPageNo] = useState(1);
  const [sales, setSales] = useState<'ON' | 'AC'>('AC');
  const [paymentStatus, setPaymentStatus] = useState<string>('AL');
  const [defSelType, setDefSelType] = useState<number>(2);

  const PA0004 = commonCodes.find(
    (item) => item.commonCode === 'PA0004',
  )?.detailCode;

  const PA0013 = commonCodes.find(
    (item) => item.commonCode === 'PA0013',
  )?.detailCode;

  const showReceipt = (uuid: string) => {
    let url = getWebUrl() + '/receipt?uuid=' + uuid;

    window.open(url, '_blank');
  };


  const doGetPaymentOverallSales = (pageNo: number, perPage?: number) => {
    if (isFirstRun) {
      setIsFirstRun(false);
      return;
    }
    const req: IPaymentOverallSalesParams = {
      campusCode: currentCampus,
      paymentChannelCode,
      orderId,
      srtDate: startDate,
      endDate: endDate,
      paymentStatus,
      pageNo,
      perPage: perPage || config.pageSize,
      sales,
    };

    setPageNo(pageNo);

    perPage
      ? execute2(getPaymentOverallSales(req))
      : execute(getPaymentOverallSales(req));
  };

  useEffect(() => {
    doGetPaymentOverallSales(pageNo);
  }, [pageNo]);

  const columns: TableColumnsType<IPaymentOverallSales> = [
    {
      title: t('payment.overallSales.25'),
      dataIndex: 'salesDttm',
      key: 'salesDttm',
      render: (text) => moment(text).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      title: t('payment.overallSales.2'),
      dataIndex: 'paymentDttm',
      key: 'paymentDttm',
      render: (text) => moment(text).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      title: t('payment.overallSales.4'),
      dataIndex: 'orderId',
      key: 'orderId',
    },
    {
      title: t('payment.record.column1'),
      dataIndex: 'paymentMtdCode',
      key: 'paymentMtdCode',
      render: (text) => getCommonCodeLabel('PA0002', text, i18n.language === 'ko' ? 'ko' : 'en'),
    },
    {
      title: t('처리방식'),
      dataIndex: 'processMtd',
      key: 'processMtd',
      align: 'center',
      render: (value, record) => (
        <Tooltip title={getCommonCodeLabel('PA0015', record.reasonCode, 'ko')}>
          <span>{getCommonCodeLabel('PA0014', value, 'ko')}</span>
        </Tooltip>
      ),
    },
    {
      title: t('payment.overallSales.5'),
      dataIndex: 'paymentStatus',
      key: 'paymentStatus',
      render: (text, record) => {
        if (text == '취소' && record.paymentAmount - (record?.refundAmount ?? 0) > 0) {
          return i18n.language === 'ko' ? '부분취소' : 'Partical cancellation';
        }
        return text;
      },
    },
    {
      title: t('payment.overallSales.6'),
      dataIndex: 'uuid',
      key: 'uuid',
      render: (uuid, record) =>
        uuid && record.approvalNumber && (
          <div className="comm-btn__area justify-content-center">
            <Button
              className="btn-basic small pink-line"
              onClick={() => showReceipt(uuid)}
              text={t('payment.overallSales.7')}
              writeAuthYn={writeAuthYn}
            />
          </div>
        ),
    },
    {
      title: t('payment.overallSales.8'),
      dataIndex: 'studentName',
      key: 'studentName',
    },
    {
      title: t('payment.overallSales.9'),
      dataIndex: 'studentCode',
      key: 'studentCode',
    },
    {
      title: t('payment.overallSales.10'),
      dataIndex: 'parentName',
      key: 'parentName',
    },
    {
      title: t('payment.overallSales.24'),
      dataIndex: 'tossAmount',
      key: 'tossAmount',
    },
    {
      title: t('payment.overallSales.13'),
      dataIndex: 'paymentChannelCode',
      key: 'paymentChannelCode',
      render: (text) => getCommonCodeLabel('PA0004', text, i18n.language == 'ko' ? 'ko' : 'en'),
    },
    {
      title: t('payment.overallSales.14'),
      dataIndex: 'cardCompany',
      key: 'cardCompany',
    },
    {
      title: t('payment.overallSales.15'),
      dataIndex: 'orderName',
      key: 'orderName',
    },
  ];

  useEffect(() => {
    if (serverDate) {
      const date = moment(serverDate).format('YYYYMMDD');
      setStartDate(date);
      setEndDate(date);
    }
  }, [serverDate]);

  useEffect(() => {
    if (res2?.data && !isLoading2) {
      const data = cloneDeep(res2.data);
      let _columns = cloneDeep(columns);
      _columns = _columns.filter(({ key }) => key !== 'receiptUrl');
      data.forEach((item) => {
        item.processMtd = getCommonCodeLabel('PA0014', item.processMtd, 'ko');
        item.paymentDttm = moment(item.paymentDttm).format(
          'YYYY-MM-DD HH:mm:ss',
        );
        if (item.refundDttm)
          item.refundDttm = moment(item.refundDttm).format(
            'YYYY-MM-DD HH:mm:ss',
          );
        // @ts-ignore
        if (item.refundAmount) item.refundAmount = `-${item.refundAmount}`;
        item.paymentChannelCode = getCommonCodeLabel(
          'PA0004',
          item.paymentChannelCode,
          'ko',
        );
      });
      const currentDate = moment(new Date());
      exportTable(
        _columns,
        data,
        `${t('payment.overallSales.16')}_(${currentDate.format('YYYYMMDD')})`,
        t('payment.overallSales.16'),
        [15, 20, 20, 10, 10, 8, 15, 10, 10, 10, 10, 15, 25],
      );
    }
  }, [res2, isLoading2]);

  return (
    <>
      <div className="common-search">
        <div className="search-area">
          <ul className="search-bx">
            <li>
              <label>{t('common.menu.campus')}</label>
              <div>
                <div>
                  <SelectCampus className="w-200" />
                </div>
                <div className="radio-area">
                <span>
                  <Radio onChange={(e) => setPaymentStatus('AL')} value={'AL'}
                         checked={paymentStatus === 'AL'} text={'전체'} />
                </span>
                  {
                    PA0013?.map((item) => {
                      return (
                        <span>
                        <Radio onChange={(e) => setPaymentStatus(e.target.value)} value={item.detailCode}
                               checked={item.detailCode == paymentStatus} text={item.korName} />
                      </span>
                      );
                    })
                  }
                </div>
              </div>
            </li>
            <li>
              <label>{t('payment.overallSales.18')}</label>
              <div>
                <Select
                  placeholder={t('payment.overallSales.18')}
                  value={sales}
                  onChange={(value) => setSales(value)}
                >
                  <Select.Option value="AC">{t('payment.overallSales.19')}</Select.Option>
                  <Select.Option value="ON">{t('payment.overallSales.20')}</Select.Option>
                </Select>
              </div>
            </li>
            <li>
              <label>{t('payment.overallSales.21')}</label>
              <div>
                <Select
                  placeholder={t('payment.overallSales.21')}
                  value={paymentChannelCode}
                  onChange={(value) => setPaymentChannelCode(value)}
                >
                  {PA0004?.map((item) => (
                    <Select.Option
                      key={item.detailCode}
                      value={item.detailCode}
                    >
                      {item.korName}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </li>
            <li>
              <label>{t('payment.overallSales.22')}</label>
              <input
                type="text"
                className="form-control w-150p"
                placeholder={t('payment.overallSales.22')}
                value={orderId}
                onChange={(e) => setOrderId(e.target.value)}
              />
            </li>
            <li className="period">
              <label>{t('sms.list.column1')}</label>
              <div className="d-flex flex-column">
                <div className="d-flex align-items-center">
                  <div className="date-picker__area">
                    <DatePicker
                      value={startDate ? moment(startDate) : undefined}
                      onChange={(e) => {
                        if (e === null) setStartDate('');
                        else setStartDate(moment(e).format('YYYYMMDD'));
                      }}
                    />
                    ~
                    <DatePicker
                      value={endDate ? moment(endDate) : undefined}
                      onChange={(e) => {
                        if (e === null) setEndDate('');
                        else setEndDate(moment(e).format('YYYYMMDD'));
                      }}
                    />
                  </div>
                  <div className="comm-btn__area">
                  <span className="ml-2 mt-2">
                    <Radio checked={true} onChange={() => console.log(1)} text={'매출일'} />
                  </span>
                    <Button
                      className="btn-basic small black"
                      onClick={() => doGetPaymentOverallSales(1)}
                      text={t('common.button.search')}
                    />
                  </div>
                </div>
                <div className="comm-btn__area mt-2">
                  <DatePickerTable
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                    type={DateTableType.ALL}
                    defSelType={defSelType}
                    setDefSelType={setDefSelType}
                  />
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className="content scrollbar">
        {(isLoading || isLoading2) && <Loader />}
        <ErrorResponse error={error} />
        <ErrorResponse error={error2} />
        <SimpleHeader
          iconFile="icon-payment-big.svg"
          parentMenu={t('payment.overallSales.17')}
          currentMenu={t('payment.overallSales.16')}
          onlyTitle={true}
        />
        <div className="col-frame">
          {res?.data.length ? (
            <>
              <div className="comm-table__area">
                <Table
                  columns={columns}
                  dataSource={res.data}
                  pagination={{ current: pageNo, pageSize: config.pageSize }}
                />
                <div className="comm-bx__between">
                  <DownloadButton onClick={() => doGetPaymentOverallSales(1, 999999999)} />
                  <div className="common-paging center">
                    <Pagination
                      count={res?.total || 0}
                      page={pageNo}
                      setPage={setPageNo}
                    />
                  </div>
                </div>
              </div>
            </>
          ) : (
            <TableEmpty text={t('payment.overallSales.23')} />
          )}
        </div>
      </div>
    </>
  );
};

export default OverallSalesNice;
